import { useRef, useState } from "react";
import "./App.css";
import ClassesSection from './ClassesSection';
import RacesSection from './RacesSection';
import AboutSection from './AboutSection';
import RoadmapSection from './RoadmapSection';
import WelcomeSection from "./WelcomeSection";
import CreateCharacterSection from "./CreateCharacterSection";
function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const aboutRef = useRef(null);
  const charactersRef = useRef(null);
  const racesRef = useRef(null);
  const mintRef = useRef(null);
  const roadmapRef = useRef(null);
  const communityRef = useRef(null);

  const scrollTo = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
    setMobileMenuOpen(false); // close mobile menu on link click
  };

  return (
    <div className="app">
      {/* Navbar */}
      <nav className="navbar">
        <img src="/logo.png" alt="Derp Quest Logo" className="logo" />

        {/* Desktop nav links */}
        <div className={`nav-links ${mobileMenuOpen ? "open" : ""}`}>
          <button onClick={() => scrollTo(aboutRef)}>About</button>
          <button onClick={() => scrollTo(charactersRef)}>Classes</button>
          <button onClick={() => scrollTo(racesRef)}>Races</button>
          <button onClick={() => scrollTo(roadmapRef)}>Roadmap</button>
          <button onClick={() => scrollTo(communityRef)}>Community</button>
        </div>

        {/* Play button */}
        <a
          className="play-button"
          href="https://app.quest.derpe.xyz"
          target="_blank"
       
          rel="noopener noreferrer"
          
        >
          PLAY
        </a>

        {/* Hamburger for mobile */}
        <div
          className={`hamburger ${mobileMenuOpen ? "open" : ""}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>

      {/* Hero */}
      <section className="hero">
        <img src="/logo.png" alt="Derp Quest Logo" className="hero-logo" />
        <h2>Derp Quest</h2>
        <p className="subtitle">An onchain adventure in the Derpeverse. Only on Sonic.</p>
        <a
          className="play-button-hero"
          href="https://app.quest.derpe.xyz"
          target="_blank"
     
          rel="noopener noreferrer"
          
        >
          Create a Character
        </a>
        <div className="swipe-indicator">Swipe to Browse</div> 
      </section>

      <WelcomeSection ref={aboutRef} />
      <CreateCharacterSection ref={mintRef} />

      {/* Sections */}
      
      <ClassesSection ref={charactersRef} />
      <RacesSection ref={racesRef}/>
      {/*
      <section ref={mintRef} className="section mint-section">
        <h2>Derp Quest Characters</h2>
        <p>
          Derp Quest Characters are an ERC721 collection at the core of Derp Quest. 
          The base cost of a Derp Quest character is 100 $DERP, increasing with better stat rolls.
        </p>
        <p>
          There are no limits to the number of characters that can exist.
          Character rolls combine a user's address with a seed number to ensure any character you discover will always be available for you to mint.
        </p>
        <a
          className="mint-button"
          href="#"
          
          rel="noopener noreferrer"
          onClick={()=>{alert("soonsoonsoonsoonsoonsoonsoonsoonsoonsoonsoonsoon")}}
        >
          Mint Your Character
        </a>
      </section>*/
}
      <RoadmapSection ref={roadmapRef} />
      <section ref={communityRef} className="section community-section">
  <h2>Join the Community</h2>
  <p>Follow us on socials and join the quest.</p>
  <div className="community-icons">
    <a href="https://twitter.com/derpedewdz" target="_blank" rel="noopener noreferrer">
      <img src="/icon--twitter.png" alt="Twitter" className="community-icon" />
    </a>
    <a href="https://discord.gg/3BUen4F9Tw" target="_blank" rel="noopener noreferrer">
      <img src="/icon--discord.png" alt="Discord" className="community-icon" />
    </a>
    <a href="https://t.me/derpedewdz" target="_blank" rel="noopener noreferrer">
      <img src="/icon--telegram.png" alt="Telegram" className="community-icon" />
    </a>
  </div>
</section>


      <footer>
        <p>© {new Date().getFullYear()} Cult NFTs. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
